import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ConfirmationDialogContext {
  message: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

export interface ConfirmationDialogState {
  isOpen: boolean;
  context: ConfirmationDialogContext | null;
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {
  private readonly stateSubject = new BehaviorSubject<ConfirmationDialogState>({
    isOpen: false,
    context: null
  });

  readonly state$ = this.stateSubject.asObservable();

  open(message: string, onConfirm: () => void, onCancel?: () => void): void {
    this.stateSubject.next({
      isOpen: true,
      context: {
        message,
        onConfirm,
        onCancel
      }
    });
  }

  close(): void {
    this.stateSubject.next({
      isOpen: false,
      context: null
    });
  }
}
